import { render } from "./ChartOfAccounts.vue?vue&type=template&id=21d8fefe&ts=true"
import script from "./ChartOfAccounts.vue?vue&type=script&lang=ts"
export * from "./ChartOfAccounts.vue?vue&type=script&lang=ts"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__